/*
 * Keeps the header's cart count badge in step with the cart.
 *
 * Horizon's own cart-icon component is tied to the header this theme replaced,
 * so the badge listens for the same storefront event it does:
 * shopify:cart:lines-update, whose promise carries the updated cart. A refetch
 * of /cart.js covers whatever reaches the cart without that event — an app's
 * own add-to-cart, or a page restored from the back/forward cache.
 */
const CART_LINES_UPDATE = 'shopify:cart:lines-update';

const badges = () => document.querySelectorAll('[data-circles-cart-count]');

const render = (count) => {
  for (const badge of badges()) {
    badge.textContent = count > 99 ? '99+' : String(count);
    badge.hidden = count === 0;
  }

  for (const label of document.querySelectorAll('[data-circles-cart-announce]')) {
    label.textContent = `${count}点の商品がカートに入っています`;
  }
};

const refetch = async () => {
  try {
    const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return;
    const cart = await response.json();
    render(cart.item_count ?? 0);
  } catch {
    // The badge keeps whatever the page was rendered with.
  }
};

document.addEventListener(CART_LINES_UPDATE, (event) => {
  const promise = /** @type {any} */ (event).promise;

  if (!promise) {
    refetch();
    return;
  }

  promise
    .then(({ cart, detail }) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (typeof count === 'number') render(count);
      else refetch();
    })
    .catch(() => refetch());
});

window.addEventListener('pageshow', (event) => {
  if (event.persisted) refetch();
});
